var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1107",
    "data-name": "Group 1107",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.08,
    height: 21.44,
    viewBox: "0 0 17.08 21.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 17.08,
    height: 21.44,
    fill: "#2e343d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M4.019,7.877V7.633q0-1.528,0-3.055A4.437,4.437,0,0,1,7.106.24a4.543,4.543,0,0,1,5.862,3.311,2.192,2.192,0,0,1,.059.414c.006.682,0,1.364,0,2.059H11.385c0-.5,0-.993,0-1.486a2.641,2.641,0,0,0-.6-1.783,2.764,2.764,0,0,0-2.823-1A2.7,2.7,0,0,0,5.768,3.832a1.742,1.742,0,0,0-.066.432c-.005,1.193,0,2.385,0,3.613h.24q4.29,0,8.58,0A2.494,2.494,0,0,1,17.01,9.833a2.757,2.757,0,0,1,.065.621q.006,4.206,0,8.412a2.5,2.5,0,0,1-2.563,2.571q-5.974.005-11.949,0A2.5,2.5,0,0,1,0,18.867Q0,14.661,0,10.455A2.509,2.509,0,0,1,2.581,7.878c.472,0,.945,0,1.438,0M8.535,19.764h5.9A.858.858,0,0,0,15.4,18.8q0-4.143,0-8.285a.858.858,0,0,0-.969-.962H2.655a.862.862,0,0,0-.978.974q0,4.132,0,8.264a.861.861,0,0,0,.979.973H8.535",
    transform: "translate(0 0)",
    fill: "#2e343d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M86.618,144.761a1.5,1.5,0,0,1-.578,1.126.312.312,0,0,0-.136.277c.006.529,0,1.059,0,1.589a.84.84,0,1,1-1.674-.009c0-.53.005-1.059-.006-1.589a.383.383,0,0,0-.123-.255,1.55,1.55,0,0,1,1.324-2.718,1.577,1.577,0,0,1,1.191,1.578",
    transform: "translate(-76.53 -131.158)",
    fill: "#2e343d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3adef1af2ae72bc5d6ba13320f8e1ec9.svg";
export { ForwardRef as ReactComponent };